import { type ComponentType } from 'react'
import { Box, Link, Stack, Typography } from '@mui/material'
import { MapPin, Phone, Mail, Clock } from 'lucide-react'
import { contact } from '@/content/site'
import { colors } from '@/theme'
import { WhatsAppIcon } from '@/components/ui/WhatsAppIcon'

function DetailRow({ icon: Icon, label, value, href }: { icon: ComponentType<{ size?: number }>; label: string; value: string; href?: string | null }) {
  return (
    <Stack direction="row" spacing={2}>
      <Box sx={{ color: 'primary.main', mt: '2px' }}>
        <Icon size={20} />
      </Box>
      <Box>
        <Typography variant="overline" sx={{ color: 'text.secondary', display: 'block' }}>
          {label}
        </Typography>
        {href ? (
          <Link href={href} variant="body1" sx={{ '&:hover': { color: 'primary.main' } }}>
            {value}
          </Link>
        ) : (
          <Typography variant="body1">{value}</Typography>
        )}
      </Box>
    </Stack>
  )
}

/** Contact details rail. Reads placeholders from the central contact config. */
export function ContactDetails() {
  return (
    <Box sx={{ p: { xs: 3, md: 4 }, bgcolor: colors.surface, border: `1px solid ${colors.border}`, borderRadius: 1 }}>
      <Stack spacing={3.5}>
        <DetailRow icon={MapPin} label="Address" value={contact.address} />
        <DetailRow icon={Phone} label="Phone" value={contact.phone} href={contact.phoneHref} />
        <DetailRow icon={Mail} label="Email" value={contact.email} href={contact.email.includes('@') ? `mailto:${contact.email}` : null} />
        <DetailRow icon={WhatsAppIcon} label="WhatsApp" value={contact.whatsapp ?? 'Coming Soon'} href={contact.whatsapp} />
        <DetailRow icon={Clock} label="Business Hours" value={contact.hours} />
      </Stack>
    </Box>
  )
}
